// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { useSafeClient } from '@safecoin/dapp-kit';
import { SafeJsonRpcClient } from '@safecoin/safe/jsonRpc';
import { useMemo } from 'react';

import { useNetwork } from '~/context';
import { Network } from '~/utils/api/DefaultRpcClient';

// TODO: Use enhanced RPC locally by default
export function useEnhancedRpcClient() {
	const [network] = useNetwork();
	const client = useSafeClient();
	const enhancedRpc = useMemo(() => {
		if (network === Network.LOCAL) {
			return new SafeJsonRpcClient({
				url: import.meta.env.VITE_INDEXER_URL || 'https://api.safecoin.dev/indexer',
				network: 'localnet',
			});
		}

		return client;
	}, [network, client]);

	return enhancedRpc;
}
